import { Controller } from "../controller";

export interface AttachClickListenerProps {
    /** The ID of the element to attach the listener to */
    elementId: string;
    /** The click handler function */
    handler: () => void;
}


export class FloatingActionButtonController extends Controller {
    constructor() {
        super({
            logLabel: "FloatingActionButtonController",
        });
    }

    attachClickListener(props: AttachClickListenerProps): void {
        const { elementId, handler } = props;
        this.bindClick({ elementId, handler });
    }
}